// SEO and site configuration
export const SITE_CONFIG = {
    // Base URL - change this if domain changes
    url: 'https://deployx.in',

    // Site metadata
    name: 'DEPLOY-X',
    title: 'DEPLOY-X – Intelligent Digital Solutions',
    description: 'DEPLOY-X delivers AI-powered, cloud-ready, and secure digital solutions for businesses. Transform your vision into reality with cutting-edge technology.',

    // Social media
    social: {
        instagram: 'https://www.instagram.com/deploy.x_?igsh=MXVobHRjMDdtbXMzbg==',
        linkedin: 'https://linkedin.com/company/deploy-x',
    },

    // Contact
    contact: {
        email: 'info.deployx@gmail.com',
        phone: '+91 7600236927',
    },

    // SEO
    keywords: 'AI solutions, web development, mobile apps, cloud services, cybersecurity, digital transformation, software development, India',
    author: 'DEPLOY-X Team',

    // Open Graph default image (update with actual image path)
    ogImage: 'https://deployx.in/og-image.jpg',
};
